import React, { Component } from 'react';
import MuckTruckClassic from "../Static/mini-dumper.jpg";
import MuckTruckMax from "../Static/muck-truck-max.jpg";
import EMuckTruck from "../Static/e-truck.jpg";
import MuckTruckHMax from "../Static/h-max.jpeg";

class PriceList extends Component {
	render() {
		return (
			<div className='content smaller'>
				<h2>CENNÍK</h2>
				<div className='price-list__product-wrap'>
					<div className='price-list__product-img'>
						<img decoding="async" className='truck-image' src={MuckTruckClassic} alt='muck-truck-classic' />
					</div>
					<div className='price-list__product-specifications'>
						<h3>MUCKTRUCK</h3>
						<div>GXV 160 Honda 5.5HP motor</div>
						<div>250kg nosnosť , (6 stôp,  posun-preskok/korba)</div>
						<div>(24 mesiacov obchodná garancia na motor)</div>
						<p className='price-list__product-price'>2.995,-€ s DPH</p>
					</div>
				</div>
				<div className='price-list__product-wrap'>
					<div className='price-list__product-img'>
						<img decoding="async" className='truck-image' src={MuckTruckMax} alt='muck-truck-max' />
					</div>
					<div className='price-list__product-specifications'>
						<h3>MAX-TRUCK</h3>
						<div>GXV 160 Honda 5.5HP motor</div>
						<div>365kg nosnosť , (8stôp,  posun-preskok/korba)</div>
						<div>(24 mesiacov obchodná garancia na motor)</div>
						<div className='price-list__product-price'>
							<div>Modrá korba - 3.295,- € s DPH</div>
							<div>Pozinkovaná korba - 3.395,- € s DPH</div>
						</div>
					</div>
				</div>
				<div className='price-list__product-wrap'>
					<div className='price-list__product-img'>
						<img decoding="async" className='truck-image' src={EMuckTruck} alt='e-muck-truck' />
					</div>
					<div className='price-list__product-specifications'>
						<h3>E-TRUCK</h3>
						<div>24 voltová batéria Benevelli napájaná 4 batériami</div>
						<div>250kg nosnosť (6 stôp,  posun-preskok/korba)</div>
						<p className='price-list__product-price column'>
							4.495,-€ s DPH
						</p>
					</div>
				</div>
				<div className='price-list__product-wrap'>
					<div className='price-list__product-img'>
						<img decoding="async" className='truck-image' src={MuckTruckHMax} alt='muck-truck-h-max' />
					</div>
					<div className='price-list__product-specifications'>
						<h3>Predstavujeme “H-MAX”</h3>
						<div>GXV 160 Honda 5.5HP motor</div>
						<div>450kg nosnosť</div>
						<div>(24 mesiacov obchodná garancia na motor)</div>
						<div>(Hydraulická technika vyklápania)</div>
						<p className='price-list__product-price column'>
							4.505,-€ s DPH
						</p>
					</div>
				</div>
				<h2 className='text-align--left width-100'>PRÍSLUŠENSTVO</h2>
				<div className='price-list__product-wrap accessories'>
					<h3>DP38</h3>
					<p className='text-align--left'>PLOCHÉ DNO</p>
					<p className='text-align--right'>274,-€</p>
				</div>
				<div className='price-list__product-wrap accessories'>
					<h3>DP70.2</h3>
					<p className='text-align--left'>BRZDOVÝ BALÍK ( verzia 2013) </p>
					<p className='text-align--right'>134,-€</p>
				</div>
				<div className='price-list__product-wrap accessories'>
					<h3>DP43</h3>
					<p className='text-align--left'>POSUVNÉ NADSTAVENIE (iba pre objemové materiály) </p>
					<p className='text-align--right'>176,-€</p>
				</div>
				<div className='price-list__product-wrap accessories'>
					<h3>DP71</h3>
					<p className='text-align--left'>SNEHOVA RADLICA (gumenné ostrie) </p>
					<p className='text-align--right'>610,-€</p>
				</div>
				<div className='price-list__product-wrap accessories'>
					<h3>DP47</h3>
					<p className='text-align--left'>NAKLADACIA RAMPA (2 ks)</p>
					<p className='text-align--right'>794,-€</p>
				</div>
				<div className='price-list__product-wrap accessories'>
					<h3>DP92</h3>
					<p className='text-align--left'>VÁKUOVÝ NADSTAVEC c/w konzoly</p>
					<p className='text-align--right'>3.089,-€</p>
				</div>
				<div className='price-list__product-wrap accessories'>
					<h3>DP61</h3>
					<p className='text-align--left'>DVOJKOLESOVÉ BRZDOVÉ SADY (pár) </p>
					<p className='text-align--right'>302,-€</p>
				</div>
				<div className='price-list__product-wrap accessories'>
					<h3>DP73</h3>
					<p className='text-align--left'>SADA PNEUMATIK NA TRÁVU c/w konzoly (pár)</p>
					<p className='text-align--right'>400,-€</p>
				</div>
				<div className='price-list__product-wrap accessories'>
					<h3>DP73MAX</h3>
					<p className='text-align--left'>SADA PNEUMATIK NA TRÁVU c/w konzoly – Max Truck </p>
					<p className='text-align--right'>536,-€</p>
				</div>
			</div>
		);
	}
}

export default PriceList;
